// Action Types

export const Types = {
  LIST_CONTRACTS_REQUESTED: 'comercial/LIST_CONTRACTS_REQUESTED',
  LIST_CONTRACTS_SUCCEEDED: 'comercial/LIST_CONTRACTS_SUCCEEDED',
  LIST_CONTRACTS_FAILED: 'comercial/LIST_CONTRACTS_FAILED',

  LIST_PROPOSALS_REQUESTED: 'comercial/LIST_PROPOSALS_REQUESTED',
  LIST_PROPOSALS_SUCCEEDED: 'comercial/LIST_PROPOSALS_SUCCEEDED',
  LIST_PROPOSALS_FAILED: 'comercial/LIST_PROPOSALS_FAILED',

  LIST_OPORTUNITIES_REQUESTED: 'comercial/LIST_OPORTUNITIES_REQUESTED',
  LIST_OPORTUNITIES_SUCCEEDED: 'comercial/LIST_LIST_OPORTUNITIES_SUCCEEDED',
  LIST_OPORTUNITIES_FAILED: 'comercial/LIST_OPORTUNITIES_FAILED',

  LIST_BIDS_REQUESTED: 'comercial/LIST_BIDS_REQUESTED',
  LIST_BIDS_SUCCEEDED: 'comercial/LIST_BIDS_SUCCEEDED',
  LIST_BIDS_FAILED: 'comercial/LIST_BIDS_FAILED',

  GET_PROPOSAL_REQUESTED: 'comercial/GET_PROPOSAL_REQUESTED',
  GET_PROPOSAL_SUCCEEDED: 'comercial/GET_PROPOSAL_SUCCEEDED',
  GET_PROPOSAL_FAILED: 'comercial/GET_PROPOSAL_FAILED',

  GET_OPORTUNITY_REQUESTED: 'comercial/GET_OPORTUNITY_REQUESTED',
  GET_OPORTUNITY_SUCCEEDED: 'comercial/GET_OPORTUNITY_SUCCEEDED',
  GET_OPORTUNITY_FAILED: 'comercial/GET_OPORTUNITY_FAILED',

  GET_LEGAL_ENTITIES_REQUESTED: 'comercial/GET_LEGAL_ENTITIES_REQUESTED',
  GET_LEGAL_ENTITIES_SUCCEEDED: 'comercial/GET_LEGAL_ENTITIES_SUCCEEDED',
  GET_LEGAL_ENTITIES_FAILED: 'comercial/GET_LEGAL_ENTITIES_FAILED',

  GET_DRAFT_CONTRACTS_REQUESTED: 'comercial/GET_DRAFT_CONTRACTS_REQUESTED',
  GET_DRAFT_CONTRACTS_SUCCEEDED: 'comercial/GET_DRAFT_CONTRACTS_SUCCEEDED',
  GET_DRAFT_CONTRACTS_FAILED: 'comercial/GET_DRAFT_CONTRACTS_FAILED',

  GET_DRAFT_CONTRACT_REQUESTED: 'comercial/GET_DRAFT_CONTRACT_REQUESTED',
  GET_DRAFT_CONTRACT_SUCCEEDED: 'comercial/GET_DRAFT_CONTRACT_SUCCEEDED',
  GET_DRAFT_CONTRACT_FAILED: 'comercial/GET_DRAFT_CONTRACT_FAILED',

  GET_CONTRACT_REQUESTED: 'comercial/GET_CONTRACT_REQUESTED',
  GET_CONTRACT_SUCCEEDED: 'comercial/GET_CONTRACT_SUCCEEDED',
  GET_CONTRACT_FAILED: 'comercial/GET_CONTRACT_FAILED',

  GET_CONTRACTS_REQUESTED: 'comercial/GET_CONTRACTS_REQUESTED',
  GET_CONTRACTS_SUCCEEDED: 'comercial/GET_CONTRACTS_SUCCEEDED',
  GET_CONTRACTS_FAILED: 'comercial/GET_CONTRACTS_FAILED',
}

// Action Creators

export function listContracts() {
  return {
    type: Types.LIST_CONTRACTS_REQUESTED,
  }
}

export function listProposals() {
  return {
    type: Types.LIST_PROPOSALS_REQUESTED,
  }
}

export function listOportunities() {
  return {
    type: Types.LIST_OPORTUNITIES_REQUESTED,
  }
}

export function listBids() {
  return {
    type: Types.LIST_BIDS_REQUESTED,
  }
}

export function getProposal(id) {
  return {
    type: Types.GET_PROPOSAL_REQUESTED,
    payload: id,
  }
}

export function getOportunity(id) {
  return {
    type: Types.GET_OPORTUNITY_REQUESTED,
    payload: id,
  }
}

export function getLegalEntities() {
  return {
    type: Types.GET_LEGAL_ENTITIES_REQUESTED,
  }
}

export function getDraftContracts() {
  return {
    type: Types.GET_DRAFT_CONTRACTS_REQUESTED,
  }
}

export function getDraftContract(id) {
  return {
    type: Types.GET_DRAFT_CONTRACT_REQUESTED,
    payload: id,
  }
}

export function getContract(id) {
  return {
    type: Types.GET_CONTRACT_REQUESTED,
    payload: id,
  }
}

export function getContracts() {
  return {
    type: Types.GET_CONTRACTS_REQUESTED,
  }
}

// Reducer

const INITIAL_STATE = {
  listContractsIsLoading: false,
  listContractsError: null,
  contracts: null,

  listProposalsIsLoading: false,
  listProposalsError: null,
  proposals: null,

  listOportunitiesIsLoading: false,
  listOportunitiesError: null,
  oportunities: null,

  listBidsIsLoading: false,
  listBidsError: null,
  bids: null,

  getProposalIsLoading: false,
  getProposalError: null,
  proposal: null,

  getOportunityIsLoading: false,
  getOportunityError: null,
  oportunity: null,

  getLegalEntitiesIsLoading: false,
  getLegalEntitiesError: null,
  legalEntities: [],

  getDraftContractsIsLoading: false,
  getDraftContractsError: null,
  draftContracts: [],

  getDraftContractIsLoading: false,
  getDraftContractError: null,
  draftContract: {},

  getContractIsLoading: false,
  getContractError: null,
  contract: {},

  getContractsIsLoading: false,
  getContractsError: null,
  getContractsData: null,
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.LIST_CONTRACTS_REQUESTED:
      return {
        ...state,
        listContractsIsLoading: true,
      }
    case Types.LIST_CONTRACTS_SUCCEEDED:
      return {
        ...state,
        listContractsIsLoading: false,
        listContractsError: null,
        contracts: action.payload,
      }
    case Types.LIST_CONTRACTS_FAILED:
      return {
        ...state,
        listContractsIsLoading: false,
        listContractsError: action.payload,
        contracts: null,
      }

    case Types.LIST_PROPOSALS_REQUESTED:
      return {
        ...state,
        listProposalsIsLoading: true,
      }
    case Types.LIST_PROPOSALS_SUCCEEDED:
      return {
        ...state,
        listProposalsIsLoading: false,
        listProposalsError: null,
        proposals: action.payload,
      }
    case Types.LIST_PROPOSALS_FAILED:
      return {
        ...state,
        listProposalsIsLoading: false,
        listProposalsError: action.payload,
        proposals: null,
      }

    case Types.LIST_OPORTUNITIES_REQUESTED:
      return {
        ...state,
        listOportunitiesIsLoading: true,
      }
    case Types.LIST_OPORTUNITIES_SUCCEEDED:
      return {
        ...state,
        listOportunitiesIsLoading: false,
        listOportunitiesError: null,
        oportunities: action.payload,
      }
    case Types.LIST_OPORTUNITIES_FAILED:
      return {
        ...state,
        listOportunitiesIsLoading: false,
        listOportunitiesError: action.payload,
        oportunities: null,
      }

    case Types.LIST_BIDS_REQUESTED:
      return {
        ...state,
        listBidsIsLoading: true,
      }
    case Types.LIST_BIDS_SUCCEEDED:
      return {
        ...state,
        listBidsIsLoading: false,
        listBidsError: null,
        bids: action.payload,
      }
    case Types.LIST_BIDS_FAILED:
      return {
        ...state,
        listBidsIsLoading: false,
        listBidsError: action.payload,
        bids: null,
      }

    case Types.GET_PROPOSAL_REQUESTED:
      return {
        ...state,
        getProposalIsLoading: true,
      }
    case Types.GET_PROPOSAL_SUCCEEDED:
      return {
        ...state,
        getProposalIsLoading: false,
        getProposalError: null,
        proposal: action.payload,
      }
    case Types.GET_PROPOSAL_FAILED:
      return {
        ...state,
        getProposalIsLoading: false,
        getProposalError: action.payload,
        proposal: null,
      }

    case Types.GET_OPORTUNITY_REQUESTED:
      return {
        ...state,
        getOportunityIsLoading: true,
      }
    case Types.GET_OPORTUNITY_SUCCEEDED:
      return {
        ...state,
        getOportunityIsLoading: false,
        getOportunityError: null,
        oportunity: action.payload,
      }
    case Types.GET_OPORTUNITY_FAILED:
      return {
        ...state,
        getOportunityIsLoading: false,
        getOportunityError: action.payload,
        oportunity: null,
      }

    case Types.GET_LEGAL_ENTITIES_REQUESTED:
      return {
        ...state,
        getLegalEntitiesIsLoading: true,
      }
    case Types.GET_LEGAL_ENTITIES_SUCCEEDED:
      return {
        ...state,
        getLegalEntitiesIsLoading: false,
        getLegalEntitiesError: null,
        legalEntities: action.payload,
      }
    case Types.GET_LEGAL_ENTITIES_FAILED:
      return {
        ...state,
        getLegalEntitiesIsLoading: false,
        getLegalEntitiesError: action.payload,
        legalEntities: [],
      }

    case Types.GET_DRAFT_CONTRACTS_REQUESTED:
      return {
        ...state,
        getDraftContractsIsLoading: true,
      }
    case Types.GET_DRAFT_CONTRACTS_SUCCEEDED:
      return {
        ...state,
        getDraftContractsIsLoading: false,
        getDraftContractsError: null,
        draftContracts: action.payload,
      }
    case Types.GET_DRAFT_CONTRACTS_FAILED:
      return {
        ...state,
        getDraftContractsIsLoading: false,
        getDraftContractsError: action.payload,
        draftContracts: [],
      }

    case Types.GET_DRAFT_CONTRACT_REQUESTED:
      return {
        ...state,
        getDraftContractIsLoading: true,
      }
    case Types.GET_DRAFT_CONTRACT_SUCCEEDED:
      return {
        ...state,
        getDraftContractIsLoading: false,
        getDraftContractError: null,
        draftContract: action.payload,
      }
    case Types.GET_DRAFT_CONTRACT_FAILED:
      return {
        ...state,
        getDraftContractIsLoading: false,
        getDraftContractError: action.payload,
        draftContract: {},
      }

    case Types.GET_CONTRACT_REQUESTED:
      return {
        ...state,
        getContractIsLoading: true,
      }
    case Types.GET_CONTRACT_SUCCEEDED:
      return {
        ...state,
        getContractIsLoading: false,
        getContractError: null,
        contract: action.payload,
      }
    case Types.GET_CONTRACT_FAILED:
      return {
        ...state,
        getContractIsLoading: false,
        getContractError: action.payload,
        contract: {},
      }

    case Types.GET_CONTRACTS_REQUESTED:
      return {
        ...state,
        getContractsIsLoading: true,
      }
    case Types.GET_CONTRACTS_SUCCEEDED:
      return {
        ...state,
        getContractsIsLoading: false,
        getContractsError: null,
        getContractsData: action.payload,
      }
    case Types.GET_CONTRACTS_FAILED:
      return {
        ...state,
        getContractsIsLoading: false,
        getContractsError: action.payload,
        getContractsData: null,
      }

    default:
      return state
  }
}
